import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const CarLoanInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section car-fin">
                <h2 className="other-pages-title">Car Loan</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/car-loan-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Car Loan</span>
                </p>
            </div>

            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is a Car Loan?</h2>

                <p className="info-loan-description-smco">
                    A car loan is a secured loan provided by banks and NBFCs to help you purchase a new or used car. 
                    The vehicle itself acts as collateral, making it easier to access funds at competitive interest rates. 
                    Car loans typically cover 80% to 100% of the on-road price of the car, depending on the lender, 
                    your eligibility, and credit profile.
                    <br /><br />
                    These loans are popular in India as they allow individuals to buy their dream vehicle 
                    without having to make the entire payment upfront. Loan tenure usually ranges from 1 to 7 years, 
                    and repayment is made through fixed monthly EMIs. With minimal documentation, quick approvals, 
                    and flexible repayment options, a car loan is one of the most convenient financing solutions for vehicle purchase.
                    <br /><br />
                    In case of default, the lender has the right to repossess the car, as it remains hypothecated until the loan is repaid in full. 
                    Therefore, it is important to plan your EMIs responsibly and ensure timely repayments. 
                    Whether you are salaried, self-employed, or a business owner, car loans provide a convenient 
                    way to own a vehicle while managing your finances better.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features of a Car Loan</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Secured loan:</strong> The car purchased acts as collateral for the loan.</li>
                        <li><strong>High financing:</strong> Covers up to 100% of the on-road price in some cases.</li>
                        <li><strong>Flexible tenure:</strong> Repayment period ranges from 12 months to 7 years.</li>
                        <li><strong>Quick approval:</strong> Most lenders approve loans within 24-48 hours.</li>
                        <li><strong>Minimal paperwork:</strong> Basic KYC, income, and address proof are required.</li>
                        <li><strong>Attractive interest rates:</strong> Rates vary based on applicant’s profile and car model.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Eligibility Criteria</h3>
                    <ul className="info-eligibility-list-smco">
                        <li><strong>Age:</strong> Applicant should be between 21 to 65 years old.</li>
                        <li><strong>Income:</strong> Stable income proof is required (salary slips, ITR, bank statements).</li>
                        <li><strong>Employment:</strong> Both salaried and self-employed individuals are eligible.</li>
                        <li><strong>KYC compliance:</strong> PAN card, Aadhaar card, voter ID, or driver’s license required.</li>
                        <li><strong>Credit history:</strong> A good credit score improves chances of approval and lower interest rates.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Interest Rates and Charges</h3>
                    <p>
                        Car loan interest rates in India generally range from 7% to 12% per annum. 
                        Additional charges may include processing fees (0.5% to 2% of the loan amount), 
                        documentation fees, and prepayment/foreclosure charges. 
                        Rates depend on the applicant’s profile, loan amount, and car type (new or used).
                    </p>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits of Car Loans</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Drive your dream car:</strong> Buy a new or pre-owned car without full upfront payment.</li>
                        <li><strong>Affordable EMIs:</strong> Spread repayment over months/years with flexible EMI options.</li>
                        <li><strong>Quick disbursal:</strong> Fast processing ensures you can own your car without delay.</li>
                        <li><strong>Build credit history:</strong> Timely EMI payments help improve your credit score.</li>
                        <li><strong>Custom loan offers:</strong> Tailored loan schemes for salaried, self-employed, and businesses.</li>
                    </ul>
                </div>
            </div>

            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default CarLoanInfo;
